import {AnyFunction} from './essentials'
import {LongId, Util} from './util'

export class Listener<Fn extends AnyFunction = () => void> {
  private newListenerCallback: (
    listener: Fn,
    id: LongId,
    isOnceListener: boolean
  ) => Promise<void> = () => Promise.resolve()
  private listeners: Map<LongId, Fn> = new Map()
  private onceListeners: Map<LongId, Fn> = new Map()

  // For subscriber
  //

  public async addOnceListener(listener: Fn): Promise<LongId> {
    const id = Util.longId()
    this.onceListeners.set(id, listener)
    await Util.catch(() => this.newListenerCallback(listener, id, true))
    return id
  }
  public async addListener(listener: Fn): Promise<LongId> {
    const id = Util.longId()
    this.listeners.set(id, listener)
    await Util.catch(() => this.newListenerCallback(listener, id, false))
    return id
  }

  public async removeListener(id: LongId | Promise<LongId>): Promise<void> {
    const idV = await id
    this.listeners.delete(idV)
  }

  //

  // For publisher
  //

  public onNewListener(
    cb: (listener: Fn, id: LongId, isOnceListener: boolean) => any
  ): void {
    this.newListenerCallback = async (listener: Fn, id, isOnceListener) => {
      const res = cb(listener, id, isOnceListener)
      if (res instanceof Promise) {
        await res
      }
    }
  }
  public async trigger(...args: Parameters<Fn>): Promise<void> {
    const listeners = [...this.listeners.values()]
    for (const ln of listeners) {
      const res = Util.catch(() => ln(...args))
      if (res instanceof Promise) {
        await res
      }
    }

    for (const id of this.onceListeners.keys()) {
      const ln = this.onceListeners.get(id)
      this.onceListeners.delete(id)
      const res = Util.catch(() => ln?.(...args))
      if (res instanceof Promise) {
        await res
      }
    }
  }

  //
}
